export default __webpack_public_path__ + "static/media/48.38358da0.jpg";